// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createQuestionablePart} from '../../shared/repositories';

export const fetchQuestionablePartReport = postArgs =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await createQuestionablePart(postArgs);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_QUESTIONABLE_PART_SEARCH_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetQuestionablePart = () => ({
    type: actions.RESET_QUESTIONABLE_PART_SEARCH_REPORT
});



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/action-creators/report.js